import { generateTypes } from '@evmos/eip712';
import { TxContext, TxPayload, createTransactionPayload } from '@evmos/transactions';
import { EIP712TypedData } from '@evmos/transactions/dist/messages/base';
import { MsgDepositParams } from '@evmos/transactions/dist/messages/gov/deposit';
import { MsgDeposit } from '../proto/v1beta1/tx_pb.js';
import { Coin } from '../proto/v1beta1/coin_pb.js';

const MSG_DEPOSIT_TYPES = {
  MsgValue: [
    { name: 'proposal_id', type: 'uint64' },
    { name: 'depositor', type: 'string' },
    { name: 'amount', type: 'TypeAmount[]' },
  ],
  TypeAmount: [
    { name: 'denom', type: 'string' },
    { name: 'amount', type: 'string' },
  ],
};

export const createTxMsgDeposit = (context: TxContext, params: MsgDepositParams): TxPayload => {
  const typedData = createEIP712MsgDeposit(context, params);
  const cosmosMsg = createCosmosMsgDeposit(context, params);
  return createTransactionPayload(context, typedData, cosmosMsg);
};

const createEIP712MsgDeposit = (context: TxContext, params: MsgDepositParams): EIP712TypedData => {
  const types = generateTypes(MSG_DEPOSIT_TYPES);
  const message = createMsgDeposit(context, params);
  return { types, message };
};

const createCosmosMsgDeposit = (context: TxContext, params: MsgDepositParams): any => {
  const depositAmount = new Coin(Object.assign({}, params.deposit));
  const depositMessage = new MsgDeposit({
    proposalId: BigInt(params.proposalId),
    depositor: context.sender.accountAddress,
    amount: [depositAmount],
  });
  return { path: MsgDeposit.typeName, message: depositMessage, };
};

export function createMsgDeposit(context: TxContext, params: MsgDepositParams): object | object[] {
  return {
    type: 'cosmos-sdk/MsgDeposit',
    value: {
      proposal_id: params.proposalId,
      depositor: context.sender.accountAddress,
      amount: [params.deposit],
    },
  };
}


